import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import WorkerCell from "components/worker/WorkerCell";

const cellBackground = worker => {
    const defaultColor = "#FFFFFF";
    const colorMap = {
        Inactive: "#FF0000",
        FullyBlocked: "#FF9999",
        PartiallyBlocked: "#FFFF99",
        OverAllocated: "#FF9933"
    };

    return !worker || typeof worker.availability !== "object"
        ? defaultColor
        : colorMap[worker.availability.status] || defaultColor;
};

class WorkersList extends React.Component {
    render() {
        const {
            workers,
            hasHelperJob,
            onWorkerSearchClick,
            onWorkerReplaceClick,
            onWorkerDetailsClick,
            onWorkerToggleTemporaryClick,
            onWorkerAddClick,
            onWorkerRemoveClick,
            hideActions
        } = this.props;

        const addUser = (
            <Button variant="success" size="sm" onClick={onWorkerAddClick}>
                <FontAwesomeIcon icon="user-plus"/>
            </Button>
        );

        const emptyContent = (
            <tr>
                <td style={{
                    width: 30
                }}/>
                <td/>
                <td style={{
                    width: 30
                }}/>
                <td style={{
                    width: 90,
                    textAlign: "right"
                }}>
                    {hideActions || addUser}
                </td>
            </tr>
        );

        const teamLeadExists = !!workers.filter((value) => value.isTeamLead).length;

        const listItems =
            workers.length === 0
                ? emptyContent
                : workers.map((worker, workerIndex) => (
                    <tr
                        key={workerIndex}
                        style={{
                            backgroundColor: cellBackground(worker),
                            border: "1px solid #D9D9D9"
                        }}
                    >
                        <WorkerCell
                            key={worker.id}
                            worker={worker}
                            hasHelperJob={hasHelperJob}
                            onWorkerSearchClick={(workerRowId, workerId) =>
                                onWorkerSearchClick(workerRowId, workerId)}
                            onWorkerReplaceClick={onWorkerReplaceClick}
                            onWorkerDetailsClick={() => onWorkerDetailsClick(worker.id)}
                            onWorkerToggleTemporaryClick={onWorkerToggleTemporaryClick}
                            onWorkerAddClick={onWorkerAddClick}
                            onWorkerRemoveClick={() => {
                                onWorkerRemoveClick(worker.rowId);
                            }}
                            hideActions={hideActions}
                        />
                    </tr>
                ));

        if (workers.length > 0 && !teamLeadExists && !hideActions) {
            listItems.unshift(
                <tr
                    key={-1}
                    style={{
                        backgroundColor: cellBackground(),
                        border: "1px solid #D9D9D9"
                    }}
                >
                    <td style={{
                        width: 30
                    }}/>
                    <td/>
                    <td style={{
                        width: 30
                    }}/>
                    <td style={{
                        width: 90,
                        textAlign: "right"
                    }}>
                        {addUser}
                    </td>
                </tr>
            );
        }

        return (
            <table
                cellPadding="5px"
                style={{
                    width: "100%"
                }}
            >
                <tbody>
                    {listItems}
                </tbody>
            </table>
        );
    }
}

WorkersList.propTypes = {
    workers: PropTypes.array.isRequired,
    hasHelperJob: PropTypes.bool.isRequired,
    onWorkerSearchClick: PropTypes.func,
    onWorkerDetailsClick: PropTypes.func,
    onWorkerToggleTemporaryClick: PropTypes.func,
    onWorkerAddClick: PropTypes.func,
    onWorkerRemoveClick: PropTypes.func,
    hideActions: PropTypes.bool
};

export default WorkersList;
